import { howItWorks } from '@/mocks/cg51';
import SectionHeading from './SectionHeading';

export default function Workflow() {
  return (
    <section id="about" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <SectionHeading
          overline="站点说明"
          title="这不是一个八卦号，是一套方法"
          note="cg51 只做一件事：把网络里混乱的吃瓜讨论，收拢成有顺序、有出处、有结论边界的信息。以下是它固定遵守的三步。"
        />

        <div className="mx-auto grid max-w-4xl grid-cols-1 gap-4 md:gap-6 sm:grid-cols-3">
          {howItWorks.map((w) => (
            <div
              key={w.step}
              className="relative flex flex-col rounded-lg border border-background-200/70 bg-background-50 p-5 md:p-6"
            >
              <span className="font-heading text-sm font-semibold text-accent-700">{w.step}</span>
              <span className="mt-4 flex h-11 w-11 items-center justify-center rounded-md bg-background-200/60 text-foreground-800">
                <i className={`${w.icon} text-xl`} />
              </span>
              <h3 className="mt-4 font-heading text-lg font-semibold text-foreground-950">{w.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{w.text}</p>
            </div>
          ))}
        </div>

        <div className="mx-auto mt-8 max-w-4xl rounded-lg border border-secondary-200 bg-secondary-100/60 px-5 py-4 md:px-6">
          <div className="flex flex-col gap-2 md:flex-row md:items-center md:gap-4">
            <i className="ri-information-line shrink-0 text-xl text-secondary-700" />
            <p className="text-xs leading-relaxed text-foreground-700 md:text-sm">
              本站为公开信息的整理与索引，所有条目均标注来源与核验等级，内容仅供参考，不代表任何最终定论。
              若发现新来源或错误，欢迎以补充线索的方式参与讨论与事件复盘。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}